export function required (name) {
  return v => !!v || `${name}を入力してください`
}

export function loginID (v) {
  return true
}

export function password (v) {
  return true
}

export function confirmCode (v) {
  return true
}

export function username (v) {
  return true
}

export function userkana (v) {
  return true
}

export function gender (v) {
  return true
}

export function birth (v) {
  return true
}

export function postal (v) {
  return true
}

export function address (v) {
  return true
}

export function phone (v) {
  return true
}

export function peoples (v) {
  return true
}

export function couponCode (v) {
  return true
}
